module.exports = __webpack_public_path__ + "media/logos/logo@2x-540e03b3.png";